import React from 'react';
import { FAQ_ITEMS } from '../data/mock';
import { useTranslation } from '../hooks/useTranslation';

export default function FAQ() {
  const { t, lang } = useTranslation();
  const items = FAQ_ITEMS[lang] || FAQ_ITEMS.fr;
  return (
    <main>
      <section className="pt-20 pb-14 lg:pt-28 lg:pb-16 bg-ivory text-center">
        <div className="max-w-3xl mx-auto px-4 animate-fade-up">
          <div className="text-[11px] tracking-luxury uppercase text-gold mb-5">{t('faq.label')}</div>
          <h1 className="font-serif text-5xl md:text-7xl font-light">{t('faq.title')}</h1>
          <p className="mt-6 text-[#666]">{t('faq.subtitle')}</p>
        </div>
      </section>

      <section className="pb-24 lg:pb-32">
        <div className="max-w-3xl mx-auto px-4">
          <div className="divide-y divide-[#EAE4D8] border-y border-[#EAE4D8]">
            {items.map((item, i) => (
              <details key={i} className="group py-6">
                <summary className="flex justify-between items-center cursor-pointer list-none font-serif text-xl md:text-2xl hover:text-gold transition-colors">
                  {item.q}
                  <span className="text-gold text-3xl font-light transition-transform group-open:rotate-45">+</span>
                </summary>
                <p className="mt-4 text-[#555] leading-relaxed whitespace-pre-line">{item.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
